import moment from "moment";
import React from "react";
import { literToKiloliter } from "../utils/utils";
import ChartDataLabels from "chartjs-plugin-datalabels";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  BarElement,
  BarController,
  TimeScale,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  BarController,
  TimeScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);


const bgColor = [
"rgba(99, 155, 245, 0.7)", 
   ' rgba(163, 199, 244, 0.7)',
]

const borderColor = [
     'rgba(147, 197, 253, 1)', 
    'rgba(37, 99, 235, 1)',
]

function WeeklyBarChart({ dates, water_data, id, hourly = false }) {
  const isWeekly = dates?.length <= 7;
//   const chartHeight = isWeekly ? "400px" : "550px";
  const barCount = dates?.length || 0;

let chartHeight;
if (barCount <= 1) chartHeight = "200px";
else if (barCount <= 3) chartHeight = "200px";    
else if (isWeekly) chartHeight = "350px";         
else chartHeight = "580px";                   


  const barThickness = dates?.length <= 7 ? 35 : dates?.length <= 15 ? 25 : 15;

  let dates_array =
    dates && !hourly
      ? dates.map((date) => moment(date).format("DD MMM"))
      : dates;

  const datas = {
    labels: dates_array,
    datasets: [
      {
        data: water_data,
        backgroundColor: new Array(50).fill(bgColor).flat(),
        borderColor: new Array(50).fill(borderColor).flat(),
        borderWidth: 1,
        minBarLength: 50,
        barThickness: barThickness,
        maxBarThickness: 50,
        categoryPercentage: 0.9,
        barPercentage: 0.8,
      },
    ],
  };

  const options = {
    indexAxis: "y",
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
    tooltip: {
    enabled: false, 
  },
      datalabels: {
        display: true,
        anchor: "end",
        align: "end",
        formatter: (value) => literToKiloliter(value),
        font: {
          weight: "bold",
        },
      },
    },
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 10,
        bottom: 0,
      },
    },
    // scales: {
    //   y: {
    //     ticks: {
    //       font: {
    //         weight: "bold",
    //       },
    //     },
    //     beginAtZero: true,
    //   },
    //   x: {
    //     ticks: {
    //       font: {
    //         weight: "bold",
    //       },
    //     },
    //     beginAtZero: true,
    //   },
    // },
    scales: {
  y: {
    ticks: {
      font: {
        weight: "bold",
      },
    },
    beginAtZero: true,
  },
  x: {
    ticks: {
      font: {
        weight: "bold",
      },
    },
    beginAtZero: true,
    title: {
      display: true,
      text: "Liters",
      font: {
        size: 14,
        weight: "bold",
      },
      padding: { top: 2 },
    },
  },
},
    elements: {
      bar: {
        borderRadius: 8,
        borderSkipped: false,
      },
    },
  };

  return (
    <div style={{ width: "100%", height: chartHeight }}>
      <Bar id={id} data={datas} options={options} />
    </div>
  );
}

export default WeeklyBarChart;
